import React from 'react';
import {PhotoPortal} from "../../community/home/PhotoPortal";
import {getBkgColor, getLargeImage} from "../../../library/components/old/profile-frame/profile/profile-picture";

export function ImageViewerWrapper(props) {
    const {handleClose,url,bg_color,photos} = props;
    return  <PhotoPortal  bkg_color={getBkgColor(bg_color)} images={[url]} onClose={(e) => {
        handleClose()
    }}/>
}